// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1lB_X","containerItemsCenter":"Skeleton_containerItemsCenter__3ntnZ"};